// extracted by mini-css-extract-plugin
export default {"wrapper":"UnBrokenBanks_wrapper__qrBZ+"};